(ns hypnos.dme.tile.field.patient-gender
  "Field for the patient gender."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.has-check.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/gender)]]
    [:div.field-body
     [:div.field.is-grouped-multiline.is-grouped
      [:div.control
       [:label.b-radio.radio
        [:input.input
         {:type      :radio
          :name      "gender"
          :disabled  disabled
          :checked   (= :gender/female (get-in @state [:patient :patient/gender :value]))
          :on-change (fn [e]
                       (let [old-value (get-in @state [:patient :patient/gender :value])
                             new-value (when (-> e .-target .-checked) :gender/female)
                             changed?  (or (get-in @state [:patient :patient/gender :dirty?])
                                           (not= new-value old-value))]
                         (swap! state assoc-in
                                [:patient :patient/gender :value]
                                new-value)
                         (swap! state assoc-in
                                [:patient :patient/gender :dirty?]
                                changed?)))
          :on-focus  (fn [_] (swap! state assoc-in
                                    [:patient :patient/gender :touched?]
                                    true))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.label/female)]]]
      [:div.control
       [:label.b-radio.radio
        [:input.input
         {:type      :radio
          :name      "gender"
          :disabled  disabled
          :checked   (= :gender/male (get-in @state [:patient :patient/gender :value]))
          :on-change (fn [e]
                       (let [old-value (get-in @state [:patient :patient/gender :value])
                             new-value (when (-> e .-target .-checked) :gender/male)
                             changed?  (or (get-in @state [:patient :patient/gender :dirty?])
                                           (not= new-value old-value))]
                         (swap! state assoc-in
                                [:patient :patient/gender :value]
                                new-value)
                         (swap! state assoc-in
                                [:patient :patient/gender :dirty?]
                                changed?)))
          :on-focus  (fn [_] (swap! state assoc-in
                                    [:patient :patient/gender :touched?]
                                    true))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.label/male)]]]]]]))
